import { addressColumn } from "./columnHelpers";

export const propertiesOwnedRelationship = {
    collapsible: true,
    title: 'Properties Owned',
    tint: 'property',
    type: 'table',
    columns: [
        addressColumn,
    ],
};
